<template>
  <div class="whs-map" ref="map">
    <div class="whs-map-toggler whs-icon" @click="toggleMap"></div>
    <div id="map"></div>
  </div>
</template>

<script>
import 'vue2-leaflet';
import { mapState, mapGetters } from 'vuex';
import { calcPrice } from '@/api';
import * as L from 'leaflet';
import 'leaflet.markercluster';

// const L = window.L;

export default {
  name: 'Map',
  data() {
    return {
      api: '',
      markers: [],
      marker_ids: [],
      tiles: null,
      map: null,
      cluster: null,
    };
  },
  computed: {
    ...mapState('hotels', {
      hotels: state => (state.useFilter ? state.hotelsFiltered : state.hotels)
    }),
    ...mapState('hotels', [
      'region',
      'hotelHoveredID',
      'useFilter',
      'hotelsWaitingInfo'
    ]),
    ...mapState('hero', ['currencyText']),
    ...mapGetters('hero', ['toLocalePrice'])
  },
  watch: {
    hotels: function(updated, old) {
      // console.log(updated, old); return;

      if (old.length !== updated.length) this.clearMarkers();
      this.addMarkers(updated);
    },
    hotelHoveredID: function(updated) {
      if (!updated) return;
      const markerFound = this.markers.find(marker => marker.id === updated);
      if (markerFound) markerFound.marker.openPopup();
    },
    region: function() {
      this.includeMap();
      // this.map.setView([this.region.latitude, this.region.longitude], 12);
    }
  },
  methods: {
    includeMap() {
      if (!this.map) this.map = L.map('map');

      this.map.setView([this.region.latitude, this.region.longitude], 12);

      if (this.region.country_code === 'RU' && this.api !== 'osm') {
        if (this.tiles) this.map.removeLayer(this.tiles);
        this.tiles = L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
          attribution:
            '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        });
        this.api = 'osm';
      }

      if (this.region.country_code !== 'RU' && this.api !== 'mapbox') {
        if (this.tiles) this.map.removeLayer(this.tiles);
        this.tiles = L.tileLayer(
          'https://api.mapbox.com/styles/v1/mapbox/outdoors-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoidXZhcm92IiwiYSI6ImNqeXU5MzJ3aDBiamczbm1kcW93cno1bjEifQ.aeewME_t3TtRzp9ukojXeg',
          { tileSize: 512, zoomOffset: -1 }
        );
        this.api = 'mapbox';
      }

      this.tiles.addTo(this.map);
    },
    addMarker(hotel) {
      if (this.markers.find((marker) => marker.id === hotel.id)) {
        return;
      }
      // console.log(hotel.id, this.markers);
      // console.log([
      //   hotel.main_info.latitude,
      //   hotel.main_info.longitude,
      //   this.map,
      // ]);
      const marker = L.marker([
        hotel.main_info.latitude,
        hotel.main_info.longitude
      ]);

      marker.bindPopup(this.createPopup(hotel));
      marker.on('mouseover', () => marker.openPopup());
      marker.on('mouseout', () => marker.closePopup());
      marker.on('click', () => {
        this.getHotelInfo(hotel.id);
        this.$router.push({
          path: `/hotels/${hotel.id}`,
          query: this.$route.query
        });
      });
      this.markers.push({
        id: hotel.id,
        marker
      });
      if (!this.cluster) {
        this.cluster = L.markerClusterGroup({
          iconCreateFunction: function(cluster) {
            const count = cluster.getChildCount();
            const digits = (count + '').length;
            return L.divIcon({
              html: count,
              className: 'whs-cluster whs-cluster-digits-' + digits,
              iconSize: null
            });
          }
        });
      }
      this.cluster.addLayer(marker);
      this.map.addLayer(this.cluster);
    },
    getHotelInfo(id) {
      if (this.hotelsWaitingInfo.includes(id)) return;
      this.$store.dispatch('hotels/getHotelInfo', id);
    },
    clearMarkers() {
      if (!this.cluster) {
        return;
      }
      this.markers.forEach(item => {
        this.cluster.removeLayer(item.marker);
      });
      this.markers = [];
    },
    addMarkers(hotels) {
      if (hotels.some(hotel => hotel.main_info && hotel.main_info.latitude)) {
        hotels
          .filter(
            hotel =>
              hotel.main_info &&
              hotel.main_info.latitude &&
              !this.markers.find(marker => marker.id === hotel.id)
          )
          .forEach(hotel => this.addMarker(hotel));
      }
    },
    createPopup(hotel) {
      const container = document.createElement('div');
      const name = document.createElement('div');
      const price = document.createElement('div');
      name.textContent = hotel.main_info.name;
      price.textContent = this.toLocalePrice(calcPrice(hotel.rates[0]));
      name.classList.add('whs-marker-name');
      price.classList.add('whs-marker-price');
      container.appendChild(name);
      container.appendChild(price);
      return container;
    },
    toggleMap() {
      this.$refs.map.classList.toggle('open');
      this.map._onResize();
    },
    calcPrice
  },
  mounted() {
    if (!this.region.latitude) return;
    this.includeMap();
    this.clearMarkers();
    this.addMarkers(this.hotels);
  }
};
</script>

<style>
.whs-list {
  width: unset !important;
  flex: 2 0 300px;
}
.whs-marker-name,
.whs-marker-price {
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  font-size: 16px;
}
.whs-marker-price {
  font-weight: 700;
}
.whs-cluster {
  background: #2d84c8;
  border-radius: 50%;
  text-align: center;
  color: white;
  font-weight: 700;
  border: 1px solid #2d84c8;
  font-family: monospace;
}

.whs-cluster:before {
  content: ' ';
  position: absolute;
  border-radius: 50%;
  z-index: -1;
  top: 1px;
  left: 1px;
  right: 1px;
  bottom: 1px;
  border: 1px solid white;
}

.whs-cluster-digits-1 {
  font-size: 13px;
  height: 28px;
  width: 28px;
  line-height: 28px;
  margin-top: -14px;
  margin-left: -14px;
}

.whs-cluster-digits-2 {
  font-size: 15px;
  height: 34px;
  width: 34px;
  line-height: 35px;
  margin-top: -17px;
  margin-left: -17px;
}

.whs-cluster-digits-2:before {
  border-width: 2px;
}

.whs-cluster-digits-3 {
  font-size: 17px;
  height: 48px;
  width: 47px;
  line-height: 45px;
  border-width: 3px;
  margin-top: -24px;
  margin-left: -24px;
}

.whs-cluster-digits-3:before {
  border-width: 3px;
}

.whs-cluster-digits-4 {
  font-size: 17px;
  height: 58px;
  width: 58px;
  line-height: 57px;
  border-width: 4px;
  margin-top: -29px;
  margin-left: -29px;
}

.whs-cluster-digits-4:before {
  border-width: 4px;
}
</style>

<style scoped>
.whs-map-toggler {
  padding: 12px;
  display: none;
  cursor: pointer;
}
.whs-map-toggler:before {
  content: '\f085';
  font-size: 24px;
  color: var(--color-main);
}

.whs-map {
  margin-left: 12px;
  flex: 2 0 300px;
  position: sticky;
  top: 0;
  max-height: 100vh;
}
#map {
  width: 100%;
  height: 100%;
}
@media (max-width: 1024px) {
  .whs-map {
    flex: 0;
    margin-left: 0;
  }
  #map {
    display: none;
  }
  .whs-map.open {
    display: flex;
    align-items: center;
  }
  .whs-map-toggler:before {
    content: '\f5a0';
  }
  .whs-map-toggler {
    display: block;
    position: fixed;
    bottom: 12px;
    right: 12px;
    background-color: var(--color-bg);
    box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
  }
  .whs-map.open .whs-map-toggler {
    position: absolute;
    z-index: 3;
    padding-right: 16px;
    padding-left: 16px;
  }
  .whs-map.open .whs-map-toggler:before {
    content: '\f00d';
  }
  .whs-map.open {
    position: fixed;
    margin: 0;
    top: 0;
    right: 0;
    left: 0;
    height: 100vh;
    z-index: 2;
  }
  .whs-map.open #map {
    display: block;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
}
</style>